import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo, useState } from 'react';
import { TransactionTypeContext } from '@/contexts/transactionType.context';
export function TransactionTypeProvider({ children }) {
    const [transactionType, setTransactionType] = useState('RENT');
    const context = useMemo(() => ({ transactionType, setTransactionType }), [transactionType, setTransactionType]);
    return (_jsx(TransactionTypeContext.Provider, { value: context, children: children }));
}
